<template>
  <el-date-picker
    v-model="val"
    class="ADatePicker"
    type="date"
    value-format="yyyy-MM-dd"
    :placeholder="placeholder"
    :size="size"
    :clearable="clearable"
    :disabled="disabled"
    :readonly="readonly"
    :picker-options="options"
    @keydown.native="handelKeydown"
    @change="handleChange"
  />
</template>
<script>
import { selector } from "@/common/mixins/selector";
import { enter_tab } from "@/common/mixins/enter_tab";

export default {
  name: "ADatePicker",
  mixins: [selector],
  data() {
    return {};
  },
  props: {
    placeholder: {
      type: String,
      default: "날짜",
    },
    size: {
      type: String,
      default: "small",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handelKeydown(e) {
      if (e.which !== 13) {
        return true;
      }
      enter_tab.methods.focusNext(this.$el);
      return false;
    },
    handleChange(e) {
      this.$emit("input", e);
      this.$emit("change", e);
    },
  },
};
</script>
